import { render, staticRenderFns } from "./unreviewed_alert.vue?vue&type=template&id=76664e01&"
import script from "./unreviewed_alert.vue?vue&type=script&lang=js&"
export * from "./unreviewed_alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports